<template>
  <div @mouseleave="handleMouseleaveNavTab()">
    <ul class="nav nav-tabs" id="warehouse-across-tabs" style="position: relative;" @mouseover="handleMouseoverNavTab()" @mouseleave="handleMouseleaveNavTab()">
      <li v-for="item in navTabs" :key="item.id" class="nav-item" :class="hoverNavTabItem(item)" @mouseover="handleMouseoverNavTabItem($event, item)" @click="handleMouseleaveNavTab()">
        <router-link :to="{name: 'Warehouse across', params: {tab: item.id, subTab: item.childs.length ? item.childs[0].id : null}}" :class="activeTab(item.id)">{{ item.name }}</router-link>
      </li>
      <div v-show="isShowDropdownMenu" class="dropdown-menu">
        <div v-for="child in dropdownMenuData.childs" :key="child.id" class="dropdown-menu-item text-size-16" @click="handleClickSubMenu(child)">
          <a
            :style="child.disabled ? '' : 'text-decoration: underline;'"
            :class="isDisableItem(child)"
            :disabled="child.disabled"
          >
            {{ child.name }}
            {{ child.disabled ? '（Coming Soon）' : '' }}
            <i v-if="!child.disabled" class="fa fa-angle-right" aria-hidden="true"></i>
        </a>
        </div>
      </div>
    </ul>
  </div>
</template>

<script>
import tabs from '@/common/warehouse-across-tabs'

export default {
  data () {
    return {
      navTabs: tabs,
      isShowDropdownMenu: false,
      dropdownMenuData: {
        currentTab: {
          id: null,
          name: null
        },
        childs: []
      }
    }
  },
  props: {
    tab: {
      type: String,
      default: 'top'
    }
  },
  methods: {
    activeTab (tabName) {
      return this.tab === tabName ? 'active' : ''
    },
    handleMouseoverNavTab () {
      this.$emit('handleShowBackdrop')
    },
    handleMouseleaveNavTab () {
      this.isShowDropdownMenu = false
      this.$emit('handleCloseBackdrop')
    },
    handleMouseoverNavTabItem (e, tab) {
      if (tab.childs.length) {
        const left = $(e.currentTarget).position().left - 5
        $('.dropdown-menu').css('left', left + 'px')
        this.isShowDropdownMenu = true
        this.dropdownMenuData.currentTab = tab
        this.dropdownMenuData.childs = tab.childs
      } else {
        this.isShowDropdownMenu = false
      }
    },
    isDisableItem (item) {
      if (item.disabled) {
        return 'disabled'
      }
    },
    handleClickSubMenu (item) {
      if (!item.disabled) {
        let to = {name: 'Warehouse across', params: {tab: this.dropdownMenuData.currentTab.id, subTab: item.id}}
        this.handleMouseleaveNavTab()
        this.$router.push(to)
      }
    },
    hoverNavTabItem (item) {
      if (this.isShowDropdownMenu && this.dropdownMenuData.currentTab.id === item.id) {
        return 'hover'
      }
      return ''
    }
  },
  watch: {
  },
  mounted () {
  }
}
</script>

<style scoped>
.nav-tabs {
  border-bottom: unset;
}
.nav-tabs > li > a {
  color: #000;
  font-size: 16px;
  font-weight: bold;
}
.nav-tabs > li > a:hover, .nav-tabs > li > a.active:hover {
  color: #bfbfbf;
  text-decoration: underline #008cc6 5px;
  text-underline-offset: 5px;
}
.nav-tabs > li.hover, .nav-tabs > li.hover > a {
  color: #bfbfbf;
  text-decoration: underline #008cc6 5px;
  text-underline-offset: 5px;
}
.nav-tabs > li > a.active{
  border: unset;
  background-color: unset;
  text-decoration: underline #008cc6 3px;
  text-underline-offset: 5px;
}
.nav-tabs .dropdown-menu {
  margin-top: 0px;
}
.dropdown-menu {
  display: block;
  border: unset;
  box-shadow: unset;
  -webkit-box-shadow: unset;
  padding: 10px;
  width: 80%;
}
a.disabled {
  color: #bfbfbf;
  pointer-events: none;
}
.dropdown-menu-title {
  width: 100%;
}
.dropdown-menu-item {
  border-bottom: 1px dotted #ccc;
  padding: 5px 10px;
  width: 60%;
}
.dropdown-menu-item:hover {
  cursor: pointer;
}
.fa-angle-right {
  float: right;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAcross/NavTabs.vue